import Pulse from "src/Component/Pulse";
import "./index.sass";
import Config from "src/Constants/Config";

interface PageProps {
  pageId: number;
  step: number;
  setStep: (step: number) => void;
}

const Page = ({ pageId, step, setStep }: PageProps) => {
  const onClick = () => setStep(6);

  return (
    <div id="page-search">
      <img className="page-search-main" src={`${Config.BASE_URL}/images/screen_${pageId}/home.jpg`} alt="" />
      <img
        className="page-search-remove"
        style={{ transition: "all .5s ease", opacity: step >= 5 ? 1 : 0 }}
        src={`${Config.BASE_URL}/images/screen_${pageId}/home-remove.jpg`}
        alt=""
      />
      <Pulse
        onClick={onClick}
        style={{
          position: "absolute",
          bottom: "var(--height-60)",
          left: "var(--width-400)",
          opacity: step >= 5 ? 0 : 1,
          zIndex: step >= 5 ? 1 : 1,
        }}
      />
    </div>
  );
};

export default Page;
